"use client"
import { useState, useEffect, useContext } from "react"
import {
  IconButton,
  Modal,
  Typography,
  Box,
  Paper,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Chip,
  Card,
  CardContent,
  alpha,
  Zoom,
  useMediaQuery,
  useTheme,
} from "@mui/material"

// Icons
import { Close as CloseIcon } from "@mui/icons-material"
import DescriptionIcon from "@mui/icons-material/Description"
import PersonIcon from "@mui/icons-material/Person"
import BusinessIcon from "@mui/icons-material/Business"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import PaymentIcon from "@mui/icons-material/Payment"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import StoreIcon from "@mui/icons-material/Store"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import HomeIcon from "@mui/icons-material/Home"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import SwapHorizIcon from "@mui/icons-material/SwapHoriz"
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"

import { ErpContext } from "../../context/ErpContext.js"
import SpinnerLading from "../misc/SpinnerComponent.js"

const ModalViewTablaDevolucion = ({ openModal, handleCloseModal, selectedTransaccion }) => {
  const [selectedTransaccionEntidad, setSelectedTransaccionEntidad] = useState(null)
  const [transaccionItems, setTransaccionItems] = useState([])
  const [calculatedTotal, setCalculatedTotal] = useState(0)
  const [totalMontoDescuento, setTotalMontoDescuento] = useState(0)
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(0)
  const [itemsMap, setItemsMap] = useState({})
  const [montoSinImpuesto, setMontoSinImpuesto] = useState(0)
  const [transaccionModificable, setTransaccionModificable] = useState([])
  const [loading, setLoading] = useState(true)

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"))
  const isMobileOrTablet = isMobile || isTablet

  const { getTransaccionItemID, getEntidadByID, getItemById ,isNavbarCollapsed, generarFacturaPDF,
  } = useContext(ErpContext)

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedTransaccion) {
          // Obtener la entidad cliente
          const entidadCliente = await getEntidadByID(selectedTransaccion.idEntidadNumero)
          setSelectedTransaccionEntidad(entidadCliente)

          // Obtener los ítems de la transacción
          const items = await getTransaccionItemID(selectedTransaccion.id)
          console.log("items de la transacción:", items)

          // Obtener los detalles de cada Item
          const itemsWithDetails = await Promise.all(
            items.map(async (item) => {
              const itemDetails = await getItemById(item.idItem) // Obtener detalles del Item
              return {
                ...item, // Mantener los datos de la transacción
                codigo: itemDetails.codigo, // Agregar el código del Item
                descripcion: itemDetails.descripcion, // Agregar la descripción del Item
              }
            }),
          )

          console.log("items con detalles:", itemsWithDetails)
          setTransaccionItems(itemsWithDetails)

          // Crear el mapa de ítems
          const itemsMap = itemsWithDetails.reduce((map, item) => {
            map[item.idItem] = {
              codigo: item.codigo,
              descripcion: item.descripcion,
            }
            return map
          }, {})

          setItemsMap(itemsMap)

          // Calcular montos
          const { montoTotal, impuestos = [], montoDescuento = 0, porcentajeDescuento = 0 } = selectedTransaccion

          // Calcular el monto total sin impuestos
          const totalSinImpuestos = impuestos.reduce((total, impuesto) => {
            return total - (impuesto.montoTotal || 0)
          }, montoTotal)

          // Aplicar descuentos
          const totalSinImpuestosYDescuento = totalSinImpuestos + montoDescuento
          const totalFinal = totalSinImpuestosYDescuento * (1 - porcentajeDescuento / 100)

          // Actualizar estados
          setCalculatedTotal(totalFinal)
          setTotalMontoDescuento(montoDescuento)
          setPorcentajeDescuento(porcentajeDescuento)
          setMontoSinImpuesto(totalSinImpuestos)
        }
      } catch (error) {
        console.error("Error al cargar los datos:", error)
      } finally {
        setLoading(false) // Ocultar el spinner independientemente del resultado
      }
    }

    fetchData()
  }, [selectedTransaccion])

  // Renderiza el spinner mientras está cargando
  if (loading) {
    return <SpinnerLading />
  }

  // Filtrar ítems canjeados (signo -)
  const itemsCanjeados = transaccionItems.filter((item) => item.signo === "-")
  // Filtrar ítems devueltos (signo +)
  const itemsDevueltos = transaccionItems.filter((item) => item.signo === "+")

  const generarPDF = async () => {
    console.log("Generando PDF para la devolución")
    const itemsTransaccion = {
        itemList: itemsCanjeados,
        itemListCanjeables: itemsDevueltos,
    }
    await generarFacturaPDF(selectedTransaccion, itemsTransaccion, selectedTransaccionEntidad, selectedTransaccion.impuestos, null, "devolucion")
  }

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-transaccion-titulo"
      aria-describedby="modal-transaccion-descripcion"
    >
      <Box
        className="modal-background"
        sx={{
          position: "absolute",
          top: isMobileOrTablet ? 0 : "50%",
          left: isMobileOrTablet ? 0 : "50%",
          transform: isMobileOrTablet ? "none" : "translate(-50%, -50%)",
          width: "100%",
          height: isMobileOrTablet ? "100vh" : "auto",
          maxHeight: isMobileOrTablet ? "100vh" : "90vh",
          display: "flex",
          alignItems: isMobileOrTablet ? "stretch" : "center",
          justifyContent: "center",
        }}
      >
        <Zoom in={openModal} timeout={300}>
          <Paper 
            className="modal-container"
            sx={{
              width: isMobileOrTablet ? "100%" : "80%",
              maxWidth: isMobileOrTablet ? "100%" : 1200,
              height: isMobileOrTablet ? "100%" : "auto",
              maxHeight: isMobileOrTablet ? "100vh" : "90vh",
              borderRadius: isMobileOrTablet ? 0 : 2,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <Box
              sx={{
                bgcolor: "#5b5b5f",
                color: "white",
                p: isMobileOrTablet ? 1.5 : 2,
                borderTopLeftRadius: isMobileOrTablet ? 0 : 8,
                borderTopRightRadius: isMobileOrTablet ? 0 : 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: isMobileOrTablet ? 1 : 2,
                position: "sticky",
                top: 0,
                zIndex: 10,
                flexShrink: 0,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 1, minWidth: 0 }}>
                <ReceiptLongIcon fontSize={isMobileOrTablet ? "small" : "medium"} />
                <Typography
                  variant={isMobileOrTablet ? "subtitle1" : "h6"}
                  component="h2"
                  className="modal-title"
                  sx={{ 
                    color: "white", 
                    borderBottom: "none", 
                    m: 0, 
                    p: 0,
                    fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem",
                    fontWeight: 600,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  Devolución #{selectedTransaccion?.id}
                </Typography>
              </Box>
              <IconButton
                onClick={handleCloseModal}
                sx={{ color: "white", flexShrink: 0 }}
                className="close-button"
                aria-label="cerrar"
                size={isMobileOrTablet ? "small" : "medium"}
              >
                <CloseIcon fontSize={isMobileOrTablet ? "small" : "medium"} />
              </IconButton>
            </Box>

            {/* Content */}
            <Box 
              sx={{ 
                p: isMobileOrTablet ? 1.5 : 3,
                flex: 1,
                overflow: "auto",
              }}
            >
              {/* Información principal */}
              <Grid container spacing={isMobileOrTablet ? 1.5 : 3} sx={{ mb: isMobileOrTablet ? 1.5 : 3 }}>
                {/* Datos ERP */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={isMobileOrTablet ? 1 : 2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: isMobileOrTablet ? "3px solid #5b5b5f" : "4px solid #5b5b5f",
                      borderRadius: isMobileOrTablet ? 1 : 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                        transform: isMobileOrTablet ? "none" : "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent sx={{ p: isMobileOrTablet ? 1.5 : 2 }}>
                      <Typography
                        variant={isMobileOrTablet ? "subtitle2" : "subtitle1"}
                        className="section-title"
                        sx={{
                          mb: isMobileOrTablet ? 1 : 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          fontSize: isMobileOrTablet ? "0.875rem" : "1rem",
                        }}
                      >
                        <BusinessIcon fontSize={isMobileOrTablet ? "small" : "medium"} sx={{ color: "#5b5b5f" }} />
                        Datos ERP
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: isMobileOrTablet ? 0.75 : 1 }}>
                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <CalendarTodayIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Fecha:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.createdAt || "N/A"}
                          </Typography>
                        </Box>

                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <DescriptionIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Tipo:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.idTipoTransaccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <StoreIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Negocio:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.negocio || "N/A"}
                          </Typography>
                        </Box>

                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <AccountCircleIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Usuario:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.usuario || "N/A"}
                          </Typography>
                        </Box>

                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <LocationOnIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Ubicación:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.ubicacion || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Entidad */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={isMobileOrTablet ? 1 : 2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: isMobileOrTablet ? "3px solid rgb(244, 177, 14)" : "4px solid rgb(244, 177, 14)",
                      borderRadius: isMobileOrTablet ? 1 : 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                        transform: isMobileOrTablet ? "none" : "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent sx={{ p: isMobileOrTablet ? 1.5 : 2 }}>
                      <Typography
                        variant={isMobileOrTablet ? "subtitle2" : "subtitle1"}
                        className="section-title"
                        sx={{
                          mb: isMobileOrTablet ? 1 : 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          fontSize: isMobileOrTablet ? "0.875rem" : "1rem",
                        }}
                      >
                        <PersonIcon fontSize={isMobileOrTablet ? "small" : "medium"} sx={{ color: "rgb(244, 177, 14)" }} />
                        Datos de la Entidad
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: isMobileOrTablet ? 0.75 : 1 }}>
                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <PersonIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Nombre:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ 
                              fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                              ml: isMobileOrTablet ? 0 : 0.5,
                              fontWeight: 500,
                            }}
                          >
                            {selectedTransaccion?.descripcionEntidad} {selectedTransaccion?.apellido || ""}
                          </Typography>
                        </Box>

                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <DescriptionIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              DNI/CUIT:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.dniCuitCuil || "N/A"}
                          </Typography>
                        </Box>

                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <HomeIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Dirección:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.direccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <LocationOnIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Localidad:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.localidad || "N/A"}
                          </Typography>
                        </Box>

                        <Box 
                          sx={{ 
                            display: "flex", 
                            alignItems: isMobileOrTablet ? "flex-start" : "center", 
                            gap: 0.5,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <LocationOnIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                            <Typography 
                              variant="body2" 
                              className="transaction-detail-label"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                            >
                              Provincia:
                            </Typography>
                          </Box>
                          <Typography 
                            variant="body2" 
                            className="transaction-detail-value"
                            sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                          >
                            {selectedTransaccion?.provincia || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Financieros */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={isMobileOrTablet ? 1 : 2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: isMobileOrTablet ? "3px solid #4CAF50" : "4px solid #4CAF50",
                      borderRadius: isMobileOrTablet ? 1 : 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                        transform: isMobileOrTablet ? "none" : "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent sx={{ p: isMobileOrTablet ? 1.5 : 2 }}>
                      <Typography
                        variant={isMobileOrTablet ? "subtitle2" : "subtitle1"}
                        className="section-title"
                        sx={{
                          mb: isMobileOrTablet ? 1 : 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          fontSize: isMobileOrTablet ? "0.875rem" : "1rem",
                        }}
                      >
                        <AttachMoneyIcon fontSize={isMobileOrTablet ? "small" : "medium"} sx={{ color: "#4CAF50" }} />
                        Datos Financieros
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: isMobileOrTablet ? 0.75 : 1 }}>
                        {/* Total */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: isMobileOrTablet ? "flex-start" : "center",
                            gap: 0.5,
                            p: isMobileOrTablet ? 0.75 : 1,
                            bgcolor: alpha("#4CAF50", 0.1),
                            borderRadius: 1,
                            flexDirection: isMobileOrTablet ? "column" : "row",
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <AttachMoneyIcon fontSize={isMobileOrTablet ? "small" : "small"} sx={{ color: "#4CAF50" }} />
                            <Typography 
                              variant={isMobileOrTablet ? "body2" : "body1"} 
                              className="transaction-detail-label" 
                              fontWeight="bold"
                              sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "1rem" }}
                            >
                              Total:
                            </Typography>
                          </Box>
                          <Typography 
                            variant={isMobileOrTablet ? "body2" : "body1"} 
                            className="value"
                            sx={{ 
                              fontSize: isMobileOrTablet ? "0.875rem" : "1rem",
                              fontWeight: "bold",
                              ml: isMobileOrTablet ? 0 : 0.5,
                            }}
                          >
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(selectedTransaccion?.montoTotal || 0)}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Medios de Pago */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={isMobileOrTablet ? 1 : 2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: isMobileOrTablet ? "3px solid #2196F3" : "4px solid #2196F3",
                      borderRadius: isMobileOrTablet ? 1 : 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                        transform: isMobileOrTablet ? "none" : "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent sx={{ p: isMobileOrTablet ? 1.5 : 2 }}>
                      <Typography
                        variant={isMobileOrTablet ? "subtitle2" : "subtitle1"}
                        className="section-title"
                        sx={{
                          mb: isMobileOrTablet ? 1 : 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          fontSize: isMobileOrTablet ? "0.875rem" : "1rem",
                        }}
                      >
                        <PaymentIcon fontSize={isMobileOrTablet ? "small" : "medium"} sx={{ color: "#2196F3" }} />
                        Medios de Pago
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: isMobileOrTablet ? 0.75 : 1 }}>
                        {selectedTransaccion?.pagos && selectedTransaccion.pagos.length > 0 ? (
                          selectedTransaccion.pagos.map((pago, idx) => (
                            <Box 
                              key={idx} 
                              sx={{ 
                                display: "flex", 
                                alignItems: isMobileOrTablet ? "flex-start" : "center", 
                                gap: 0.5,
                                flexDirection: isMobileOrTablet ? "column" : "row",
                              }}
                            >
                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <PaymentIcon fontSize={isMobileOrTablet ? "small" : "small"} color="action" />
                                <Typography 
                                  variant="body2" 
                                  className="transaction-detail-label"
                                  sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", fontWeight: 600 }}
                                >
                                  {pago.descripcion}:
                                </Typography>
                              </Box>
                              <Typography 
                                variant="body2" 
                                className="value"
                                sx={{ fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem", ml: isMobileOrTablet ? 0 : 0.5 }}
                              >
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(pago.monto || 0)}
                              </Typography>
                            </Box>
                          ))
                        ) : (
                          <Typography 
                            variant="body2" 
                            sx={{ 
                              fontStyle: "italic",
                              fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                            }}
                          >
                            No hay información de pagos
                          </Typography>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* Tabla de Ítems Canjeados */}
              <Box sx={{ mb: isMobileOrTablet ? 1.5 : 3 }}>
                <Typography
                  variant={isMobileOrTablet ? "subtitle1" : "h6"}
                  className="items-title"
                  sx={{
                    mb: isMobileOrTablet ? 1 : 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    color: "#e74c3c",
                    fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem",
                    fontWeight: 600,
                  }}
                >
                  <SwapHorizIcon fontSize={isMobileOrTablet ? "small" : "medium"} sx={{ color: "#e74c3c" }} />
                  Ítems Canjeados
                </Typography>

                <TableContainer
                  component={Paper}
                  elevation={isMobileOrTablet ? 1 : 3}
                  className="tableContainerItemList"
                  sx={{
                    borderRadius: isMobileOrTablet ? 1 : 2,
                    overflow: "auto",
                    maxHeight: isMobileOrTablet ? 200 : 300,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                    },
                    borderLeft: isMobileOrTablet ? "3px solid #e74c3c" : "4px solid #e74c3c",
                  }}
                >
                  <Table stickyHeader size={isMobileOrTablet ? "small" : "medium"}>
                    <TableHead>
                      <TableRow sx={{ bgcolor: alpha("#e74c3c", 0.1) }}>
                        <TableCell 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Descripción
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Cantidad
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Precio
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Desc.
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Total
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {itemsCanjeados.length > 0 ? (
                        itemsCanjeados.map((item, index) => {
                          const precio = item.precio || 0
                          const cantidad = item.cantidad || 0
                          const descuento = item.porcentajeDescuento || 0
                          const totalItem = (precio * cantidad * (1 - descuento / 100)).toFixed(2)

                          const foundItem = itemsMap[item.idItem]

                          return (
                            <TableRow
                              key={`${item.idTransaccion}-${item.idItem}-${index}`}
                              className={index % 2 === 0 ? "row-color-default" : "row-color-alt"}
                              sx={{
                                transition: "background-color 0.2s ease",
                                "&:hover": {
                                  backgroundColor: alpha("#e74c3c", 0.05),
                                },
                              }}
                            >
                              <TableCell 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                <Typography 
                                  variant="body2" 
                                  fontWeight="medium"
                                  sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}
                                >
                                  {foundItem 
                                    ? isMobileOrTablet 
                                      ? `${foundItem.codigo} - ${foundItem.descripcion.substring(0, 30)}${foundItem.descripcion.length > 30 ? '...' : ''}`
                                      : `${foundItem.codigo} - ${foundItem.descripcion}`
                                    : "No encontrado"}
                                </Typography>
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                <Chip 
                                  label={cantidad} 
                                  size={isMobileOrTablet ? "small" : "small"} 
                                  color="error" 
                                  variant="outlined"
                                  sx={{ 
                                    height: isMobileOrTablet ? 20 : 24,
                                    fontSize: isMobileOrTablet ? "0.65rem" : "0.75rem",
                                  }}
                                />
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                  fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                                }}
                              >
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(precio)}
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                {descuento > 0 ? (
                                  <Chip 
                                    label={`${descuento}%`} 
                                    size={isMobileOrTablet ? "small" : "small"} 
                                    color="secondary" 
                                    variant="outlined"
                                    sx={{ 
                                      height: isMobileOrTablet ? 20 : 24,
                                      fontSize: isMobileOrTablet ? "0.65rem" : "0.75rem",
                                    }}
                                  />
                                ) : (
                                  <Typography sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>0%</Typography>
                                )}
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                  fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                                  fontWeight: "bold",
                                }}
                              >
                                <span className="value">
                                  {new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(totalItem)}
                                </span>
                              </TableCell>
                            </TableRow>
                          )
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                            <Typography variant="body1" color="text.secondary">
                              No se canjeó por ningún ítem
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Tabla de Ítems Devueltos */}
              <Box sx={{ mb: isMobileOrTablet ? 1.5 : 3 }}>
                <Typography
                  variant={isMobileOrTablet ? "subtitle1" : "h6"}
                  className="items-title"
                  sx={{
                    mb: isMobileOrTablet ? 1 : 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    color: "#4CAF50",
                    fontSize: isMobileOrTablet ? "0.875rem" : "1.25rem",
                    fontWeight: 600,
                  }}
                >
                  <KeyboardReturnIcon fontSize={isMobileOrTablet ? "small" : "medium"} sx={{ color: "#4CAF50" }} />
                  Ítems Devueltos
                </Typography>

                <TableContainer
                  component={Paper}
                  elevation={isMobileOrTablet ? 1 : 3}
                  className="tableContainerItemList"
                  sx={{
                    borderRadius: isMobileOrTablet ? 1 : 2,
                    overflow: "auto",
                    maxHeight: isMobileOrTablet ? 200 : 300,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: isMobileOrTablet ? "none" : "0 8px 16px rgba(0,0,0,0.1)",
                    },
                    borderLeft: isMobileOrTablet ? "3px solid #4CAF50" : "4px solid #4CAF50",
                  }}
                >
                  <Table stickyHeader size={isMobileOrTablet ? "small" : "medium"}>
                    <TableHead>
                      <TableRow sx={{ bgcolor: alpha("#4CAF50", 0.1) }}>
                        <TableCell 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Descripción
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Cantidad
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Precio
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Desc.
                        </TableCell>
                        <TableCell 
                          align="right" 
                          className="table-header-cell"
                          sx={{ 
                            fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                            py: isMobileOrTablet ? 0.75 : 1,
                            px: isMobileOrTablet ? 0.5 : 1,
                          }}
                        >
                          Total
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {itemsDevueltos.length > 0 ? (
                        itemsDevueltos.map((item, index) => {
                          const precio = item.precio || 0
                          const cantidad = item.cantidad || 0
                          const descuento = item.porcentajeDescuento || 0
                          const totalItem = (precio * cantidad * (1 - descuento / 100)).toFixed(2)

                          const foundItem = itemsMap[item.idItem]

                          return (
                            <TableRow
                              key={`${item.idTransaccion}-${item.idItem}-${index}`}
                              className={index % 2 === 0 ? "row-color-default" : "row-color-alt"}
                              sx={{
                                transition: "background-color 0.2s ease",
                                "&:hover": {
                                  backgroundColor: alpha("#4CAF50", 0.05),
                                },
                              }}
                            >
                              <TableCell 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                <Typography 
                                  variant="body2" 
                                  fontWeight="medium"
                                  sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}
                                >
                                  {foundItem 
                                    ? isMobileOrTablet 
                                      ? `${foundItem.codigo} - ${foundItem.descripcion.substring(0, 30)}${foundItem.descripcion.length > 30 ? '...' : ''}`
                                      : `${foundItem.codigo} - ${foundItem.descripcion}`
                                    : "No encontrado"}
                                </Typography>
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                <Chip 
                                  label={cantidad} 
                                  size={isMobileOrTablet ? "small" : "small"} 
                                  color="success" 
                                  variant="outlined"
                                  sx={{ 
                                    height: isMobileOrTablet ? 20 : 24,
                                    fontSize: isMobileOrTablet ? "0.65rem" : "0.75rem",
                                  }}
                                />
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                  fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                                }}
                              >
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(precio)}
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                }}
                              >
                                {descuento > 0 ? (
                                  <Chip 
                                    label={`${descuento}%`} 
                                    size={isMobileOrTablet ? "small" : "small"} 
                                    color="secondary" 
                                    variant="outlined"
                                    sx={{ 
                                      height: isMobileOrTablet ? 20 : 24,
                                      fontSize: isMobileOrTablet ? "0.65rem" : "0.75rem",
                                    }}
                                  />
                                ) : (
                                  <Typography sx={{ fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem" }}>0%</Typography>
                                )}
                              </TableCell>
                              <TableCell 
                                align="right" 
                                className="table-cell"
                                sx={{ 
                                  py: isMobileOrTablet ? 0.75 : 1,
                                  px: isMobileOrTablet ? 0.5 : 1,
                                  fontSize: isMobileOrTablet ? "0.7rem" : "0.875rem",
                                  fontWeight: "bold",
                                }}
                              >
                                <span className="value">
                                  {new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(totalItem)}
                                </span>
                              </TableCell>
                            </TableRow>
                          )
                        })
                      ) : (
                        <TableRow>
                          <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                            <Typography variant="body1" color="text.secondary">
                              No hay ítems devueltos para mostrar
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Acciones */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: isMobileOrTablet ? "center" : "flex-end",
                  gap: isMobileOrTablet ? 1 : 2,
                  borderTop: "1px solid #eee",
                  pt: isMobileOrTablet ? 1.5 : 2,
                  flexShrink: 0,
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<PictureAsPdfIcon fontSize={isMobileOrTablet ? "small" : "medium"} />}
                  onClick={generarPDF}
                  size={isMobileOrTablet ? "small" : "medium"}
                  fullWidth={isMobileOrTablet}
                  sx={{
                    bgcolor: "#5b5b5f",
                    fontSize: isMobileOrTablet ? "0.75rem" : "0.875rem",
                    py: isMobileOrTablet ? 0.75 : 1,
                    "&:hover": {
                      bgcolor: alpha("#5b5b5f", 0.9),
                    },
                  }}
                >
                  Generar PDF
                </Button>
              </Box>
            </Box>
          </Paper>
        </Zoom>
      </Box>
    </Modal>
  )
}

export default ModalViewTablaDevolucion
